export default __webpack_public_path__ + "static/media/dot-active.f15e2348.svg";